import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  PostApplicationsInsuranceBody,
  PostApplicationsInsuranceResponse,
} from "api/api/applicationsApi/types";

export const postApplicationsInsurance = createAsyncThunk<
  PostApplicationsInsuranceResponse,
  PostApplicationsInsuranceBody
>("applications/postApplicationsInsurance", async (body, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.postApplicationsInsurance(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while posting applications insurance", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while posting applications insurance", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});